import resultsTemplate from "@partials/results.handlebars";
import axios from "@main/axios";
import Chart from "chart.js";
import {CHART_LINE_COLOR} from "@main/constants";
import {PdfCreator} from "./pdf-creator";
import {Toggle} from "@main/components/toggle";

export class Results {
    constructor(el) {
        this.el = el;
        this.url = this.el.dataset.url;
        this.url_1c = this.el.dataset.url_1c;
        this.initEvents();
    }

    initEvents() {
        document.addEventListener("click", (e) => {
            let link = e.target;
            if (link.classList.contains("js-get-result")) {
                this.send1CData(link.dataset.id);
                link.classList.remove("js-get-result");
            }

            if (link.classList.contains("js-results-link")) {
                e.preventDefault();
                this.sendData(link.dataset.id);
            }
            if (link.classList.contains("js-get-pdf") || link.closest(".js-get-pdf")) {
                e.preventDefault();
                if (!link.classList.contains("js-get-pdf")) {
                    link = link.closest(".js-get-pdf");
                }
                if (this.el.dataset.id !== link.dataset.id) {
                    this.sendData(link.dataset.id, true, link.dataset.pdfName);
                } else {
                    new PdfCreator(this.el, link.dataset.pdfName).generate();
                }
            }
        });
    }

    send1CData = async (id) => {
        const params = {
            id: id
        };
        await axios({
            url: this.url_1c,
            params,
            method: "post"
        });
    }

    sendData = async (id, pdf = false, pdfName = "") => {
        try {
            if (this.el.classList.contains("waiting")) {
                return;
            }
            this.el.classList.add("waiting");
            const params = {
                id: id
            };
            const response = await axios({
                url: this.url,
                params,
                method: "get",
            });
            this.el.classList.remove("waiting");
            if (!response?.data) {
                this.showError("Что-то пошло не так...\nПожалуйста, перезагрузите страницу.");
                return;
            }
            if (response.data.success) {
                if (response.data.data) {
                    this.el.dataset.id = response.data.data.results.id;
                    this.el.innerHTML = resultsTemplate({results: response.data.data.results});
                    this.canvas = this.el.querySelector(".js-chart-canvas");
                    if (this.canvas && response.data.data.results.chart) {
                        this.drawChart(response.data.data.results.chart, pdf, pdfName);
                    }
                } else {
                    this.el.innerHTML = response.data.message
                }
            } else {
                this.showError(response.data.message);
            }
        } catch (error) {
            this.showError(error);
            this.el.classList.remove("waiting");
        }
    }

    showError(error) {
        this.el.innerHTML = "<div class='results__error'>" + error + "</div>";
    }

    drawChart(data, pdf = false, pdfName = "") {
        if (!data) {
            return;
        }
        const ctx = this.canvas.getContext("2d");
        Chart.defaults.global.defaultFontSize = 10;
        let chartData = {
            labels: data.labels,
            datasets: [
                {
                    fill: false,
                    borderColor: CHART_LINE_COLOR,
                    backgroundColor: CHART_LINE_COLOR,
                    borderWidth: 1,
                    data: data.levels,
                    type: "line",
                    pointRadius: 0,
                    pointHoverRadius: 0,
                    spanGaps : true,
                    lineTension: 0,
                }
            ]
        };
        new Chart(ctx, {
            type: "line",
            data: chartData,
            options: {
                responsive: false,
                scales: {
                    xAxes: [
                        {
                            position: "top",
                        },
                        {
                            position: "bottom",
                            ticks: {
                                callback: function(label) {
                                    const index = data.labels.indexOf(label);
                                    if (data.bottomLabels && data.bottomLabels[index]) {
                                        return data.bottomLabels[index];
                                    }
                                    return label;
                                }
                            }
                        },
                    ],
                    yAxes: [{
                        ticks: {
                            stepSize: 10,
                            max: 100,
                            min: -100,
                        },
                    }],
                    xAxis2: {
                        type: "category",
                        position: "bottom",
                        grid: {
                            drawOnChartArea: false,
                        },
                        ticks: {
                            callback: function(label) {
                                console.log(label);
                                /*const index = data.labels.indexOf(label);
                                if (index && data.labelsLetters) {
                                    return data.labelsLetters[index];
                                }
                                return "";*/
                                return "";
                            }
                        }
                    },
                },
                legend: {
                    display: false,
                },
                tooltips: {
                    // Disable the on-canvas tooltip
                    enabled: false,
                },
                bezierCurve : false,
                animation: {
                    onComplete: () => {
                        if (pdf) {
                            new PdfCreator(this.el, pdfName).generate();
                        } else {
                            this.el.querySelectorAll(".js-toggle").forEach(elem => new Toggle(elem));
                        }
                    }
                }
            },
        });
    }
}

document.querySelectorAll(".js-results").forEach(elem => new Results(elem));
